exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-subtitle[data-v-f913f12e]{display:inline-block}li[data-v-f913f12e]{margin-bottom:1rem}li[data-v-f913f12e]:last-child{margin-bottom:0}.description[data-v-f913f12e]{margin-bottom:1rem}.info.row[data-v-f913f12e]{margin-bottom:-1rem}.info.row>div[data-v-f913f12e]{margin-bottom:1rem}.schedule .day[data-v-f913f12e]{visibility:hidden}.schedule .first-day[data-v-f913f12e]{visibility:visible}.calendar[data-v-f913f12e]{margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f913f12e","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Colloquium/ChildrensProgram.vue
// module id = 1242
// module chunks = 0